<template>
  <v-container>
    <v-card flat>
      <v-card-subtitle
        class="justify-center text-center"
        style="word-break: normal; font-weight:600"
        >{{ activePoll.pollText }}</v-card-subtitle
      >
      <v-card-text class="text-center" v-if="errors.length">
        <div
          style="color:red;"
          v-for="(error, index) in errors"
          v-bind:key="index"
        >
          {{ error.msg }}
        </div>
      </v-card-text>
      <v-divider class="pb-m1"></v-divider>
      <!-- STATUS READY -->
      <div v-if="status === 'ready'">
        <v-card-text>
          <Radio :poll="activePoll" v-model="voteResponse" />
        </v-card-text>
        <v-card-actions class="pt-0 pb-5 justify-center">
          <v-btn
            :loading="loading"
            :disabled="!voteResponse"
            small
            outlined
            color="primary"
            @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </div>

      <!-- STATUS EDIT -->
      <div v-if="status === 'edit'">
        <v-card-text>
          <Radio :poll="activePoll" v-model="voteResponse" />
        </v-card-text>
        <v-card-actions class="pt-0 pb-5 justify-center">
          <v-btn
            :loading="loading"
            :disabled="!voteResponse"
            small
            outlined
            color="primary"
            @click="submitEdit"
            ><v-icon class="pr-1" small>mdi-check</v-icon>Submit</v-btn
          >
          <v-btn outlined small color="primary" @click="editCancel"
            ><v-icon class="pr-1" small>mdi-close</v-icon>cancel</v-btn
          >
        </v-card-actions>
      </div>

      <!-- STATUS SUBMITTED -->
      <div v-if="status === 'submitted'">
        <v-card-text
          v-if="user.scrutineer && activePoll.showResults !== 'always'"
          ><div class="text-center pb-4" style="color:red;">
            Only scrutineers can see results during a live poll
          </div>
          <VoteResults :voteResponse="voteResponse"
        /></v-card-text>
        <v-card-text v-else-if="activePoll.showResults === 'always'"
          ><VoteResults :voteResponse="voteResponse"
        /></v-card-text>
        <v-card-text class="text-center" v-else>
          <strong
            >You answered:
            {{ $store.getters.getAnswerValue(voteResponse).join(", ") }}</strong
          ><br />
          Voting results are not being shown for this poll.<br
        /></v-card-text>
        <v-card-text class="pt-0 pb-5 text-center justify-center"
          >Thank you. Your vote has been recorded.</v-card-text
        >
        <v-card-actions
          v-if="activePoll.allowEdit"
          class="pt-0 pb-5 justify-center"
        >
          <v-btn
            :disabled="!voteResponse"
            outlined
            small
            color="primary"
            @click="editResponse"
            ><v-icon class="pr-1" small>mdi-pencil</v-icon>edit response</v-btn
          >
        </v-card-actions>
      </div>
    </v-card>
  </v-container>
</template>
<script>
// @ is an alias to /src
import client from "@/services/axios";
import Radio from "@/components/Questions/Radio.vue";
import VoteResults from "@/components/Results/VoteResults.vue";
import { mapState } from "vuex";

export default {
  name: "LivePoll",
  components: {
    Radio,
    VoteResults
  },
  //props: ["poll"],
  data() {
    return {
      loading: false,
      status: "", // waiting, ready, submitted, edit, closed
      voteResponse: "",
      voteResponsePrevious: "",
      socket: {},
      errors: []
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      event: (state) => state.event,
      history: (state) => state.history,
      activePoll: (state) => state.activePoll
    })
  },
  async created() {
    this.status = "ready";
    this.getPollHistory();
  },

  methods: {
    editCancel() {
      //this.displayPoll(this.activePoll);
      this.voteResponse = this.voteResponsePrevious;
      this.status = "submitted";
    },
    editResponse() {
      // API edit response in database
      this.voteResponsePrevious = this.voteResponse.slice(0);
      //console.log('PREV', this.voteResponsePrevious);
      //console.log('CURR', this.voteResponse);
      this.status = "edit";
    },

    getAnswerTitles(ids) {
      // Filter out matching answers
      const findTitles = this.activePoll.answers.filter((answer) =>
        ids.includes(answer._id)
      );
      // map only the titles to an array
      const titles = findTitles.map((answer) => answer.title);

      return titles;
    },
    getAnswerIds(voteResponse) {
      if (Array.isArray(voteResponse)) return voteResponse;
      if (this.voteResponse) return [voteResponse];
      return false;
    },

    async submitEdit() {
      this.errors = [];
      try {
        await client.delete(`/votes/${this.user._id}/${this.activePoll._id}`);
        await this.submit();
      } catch (err) {
        this.loading = false;
        this.errors.push({ msg: err.error });
      }
    },

    async submit() {
      this.loading = true;
      this.errors = [];
      const voteData = {
        userId: this.user._id,
        pollId: this.activePoll._id,
        eventId: this.user.eventId,
        voteResponse: this.getAnswerTitles(this.voteResponse),
        answerIds: this.getAnswerIds(this.voteResponse),
        pollText: this.activePoll.pollText,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email,
        role: this.user.role
      };
      try {
        await client.post("/votes", voteData);

        this.$socket.client.emit("voteSubmitted", voteData);
        this.$store.commit("SET_HISTORY", voteData);
        this.status = "submitted";
        this.loading = false;
      } catch (err) {
        this.loading = false;
        if (err.response.data.errors !== undefined) {
          return (this.errors = err.response.data.errors);
        }
        this.errors.push({ msg: err.response.data.error });
      }
    },
    async getPollHistory() {
      console.log(this.history);
      if (!this.history.has(this.activePoll._id)) {
        this.voteResponse = "";
        return;
      }

      const history = this.history.get(this.activePoll._id).answerIds;

      if (!this.activePoll.multiple) {
        this.voteResponse = history[0];
      } else {
        this.voteResponse = history;
      }
      this.status = "submitted";
    }
  }
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 10px;
  padding-top: 5px;
}

.container {
  padding: 0 !important;
}

html {
  /*overflow:auto;*/
}
</style>
